import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SidebarContext from './SidebarContext';
import UserContext from '../User/UserContext';

const SidebarProvider = ({ children }) => {
  const { loaded, me, users } = useContext(UserContext);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    if (loaded && me) {
      // Check for persisted user selection
      const persistedUser = localStorage.getItem('selectedUser');

      if (persistedUser && users && users.some((user) => user.Username === persistedUser)) {
        // Use persisted user if it exists in the current users list
        setSelected(persistedUser);
      } else {
        // Default to logged-in user
        setSelected(me.username);
      }
    }
  }, [loaded, me, users]);

  // Persist selected user when it changes
  const handleSetSelected = (username) => {
    setSelected(username);
    localStorage.setItem('selectedUser', username);
  };

  if (!loaded || !selected) {
    return null;
  }

  return (
    <SidebarContext.Provider value={{ selected, setSelected: handleSetSelected }}>
      {children}
    </SidebarContext.Provider>
  );
};

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SidebarProvider;
